export default __webpack_public_path__ + "media/acclamation.0059ea18.mp3";